import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import LoginModal from "../../Pages/Users/LoginModal";
import OtherInfo from "../../Pages/Users/OtherInfo";
import LanguageModal from "../Common/Model/LanguageModal";
import NotificationBell from "../Utility/NotificationBell";
import Sharepop from "../Utility/SharePop";
import SearchBar from "./SearchBar";

function Header() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [showOtherInfoModal, setShowOtherInfoModal] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [banners, setBanners] = useState([]);
  const [loadingBanner, setLoadingBanner] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const navigate = useNavigate();
  const { slug } = useParams();
  const experienceId = slug?.split("-").pop();

  const [user, setUser] = useState(null);
  const [headerLogo, setHeaderLogo] = useState(null);
  const [homeLogo, sethomeLogo] = useState(null);
  const [loginType, setLoginType] = useState(1); // 1 = Guest, 2 = Host
  const [showShare, setShowShare] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [searchParams] = useSearchParams();

  const handleSearch = async ({
    id,
    type,
    name,
    date,
    arrive,
    depart,
    guest,
    adults,
    children,
    infants,
  }) => {
    try {
      setLoading(true);

      const params = {
        search: name,
         date:
    arrive && depart
      ? `${arrive} to ${depart}`
      : arrive || "",
        guest,
      };

      const selectedCurrency = JSON.parse(
        localStorage.getItem("selectedCurrency"),
      );
      if (selectedCurrency && selectedCurrency.id) {
        params.currency_id = selectedCurrency.id || 6;
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getHomeExperienceSearch`,
        { params },
      );

      if (res.data.data) {
        const searchResults = res.data.data.map((item) => {
          const title = item.title
            ? item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")
            : "unknown";
          return {
            ...item,
            img: `${res.data.base_url}${item.image}`,
            slug: `${title}-${item.experience_id || "noida"}`,
          };
        });

        // navigate("/experiences", {
        //   state: {
        //     results: searchResults,

        //     filters: {
        //       search: name,
        //       date,
        //       guest,
        //       adults,
        //       children,
        //       infants,
        //     },

        //     currency: res.data.currency || selectedCurrency, // ← pass currency here
        //   },
        // });

        const queryParams = new URLSearchParams({
          location_search: name || "",
          arrive: arrive || "",
          depart: depart || "",
          guest: guest || 0,
          child: children || 0,
          infants: infants || 0,
          page: 1,
          view: "list",
        });

        navigate(`/experiences?${queryParams.toString()}`);

        if (window.innerWidth <= 768) {
          // 👇 Force full reload for mobile
          navigate(0);
        }
      }
    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const expiry = localStorage.getItem("expiry");
    if (expiry && Date.now() > Number(expiry)) {
      // ✅ Session expired → remove everything
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
      localStorage.removeItem("expiry");
      localStorage.removeItem("hostData");
      localStorage.removeItem("userWishlist");
      localStorage.removeItem("selectedCurrency");
      localStorage.removeItem("pendingHid");
      localStorage.removeItem("pendingEid");
    }
  }, []);

  const location = useLocation();
  // const isHome = location.pathname === "/";
  const isHome = location.pathname === "/";
  const isExperiences =
    location.pathname === "/experiences" ||
    location.pathname.startsWith("/experience/");
  const isExpeienceShare =
    location.pathname.startsWith("/experience/") &&
    location.pathname.split("/").length > 2;

  const filters =
    location.state && location.state.filters ? location.state.filters : {};

  const disableCurrency =
    location.pathname.startsWith("/checkout") ||
    location.pathname.startsWith("/thankyou");

  // Fetch Logo of header

  const fetchHeaderLogo = async () => {
    try {
      const [otherbanner, homebanner] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_API_BASE}/getWebSettingsByCategory/header_logo/headerlogo`,
        ),
        axios.get(
          `${process.env.REACT_APP_API_BASE}/getWebSettingsByCategory/header_logo/bannerogo`,
        ),
      ]);

      if (
        otherbanner.data &&
        otherbanner.data.status &&
        otherbanner.data.data
      ) {
        const fileName = otherbanner.data.data.title; // get last part (image.png)
        const fullPath = otherbanner.data.base_url + fileName;

        setHeaderLogo(fullPath);
      }
      if (homebanner.data && homebanner.data.status && homebanner.data.data) {
        const fileName = homebanner.data.data.title; // get last part (image.png)
        const fullPath = homebanner.data.base_url + fileName;

        sethomeLogo(fullPath);
      }
    } catch (err) {
      console.error("Error fetching header logo:", err);
    }
  };

  useEffect(() => {
    fetchHeaderLogo();
  }, []);

  //fecht places for search bar

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/getCities`,
        );
        if (res.data && res.data.data) {
          // setCities(res.data.data);
          setCities(
            res.data.data.filter(
              (item) => item.type === "city" || item.type === "country",
            ),
          );
        }
      } catch (err) {
        console.error("Error fetching cities:", err);
      }
    };
    fetchCities();
  }, []);
  useEffect(() => {
    const closeOnClickOutside = () => setIsOpen(false);
    if (isOpen) {
      document.addEventListener("click", closeOnClickOutside);
    }
    return () => document.removeEventListener("click", closeOnClickOutside);
  }, [isOpen]);

  // Sticky header scroll check
  useEffect(() => {
    const header = document.getElementById("fixedds");
    const stickyPoint = header?.offsetTop || 0;

    const handleScroll = () => {
      setIsSticky(window.pageYOffset > stickyPoint);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Check mobile resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle show-menu on body
  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    document.body.classList.toggle("show-menu");
  };
  // share  function
  const toggleShare = (e) => {
    e.preventDefault();
    setShowShare((prev) => !prev);
  };

  // Wishlist
  const handleWishlist = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setLoginOpen(true);
        return;
      }

      const storedWishlist =
        JSON.parse(localStorage.getItem("userWishlist")) || [];

      // Check if already wishlisted
      if (isWishlisted) {
        // 🔹 Remove from wishlist API
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE}/user/removeFromWishlist`,
          { experience_id: experienceId },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (res.data.status) {
          setIsWishlisted(false);
          toast.success("Removed from wishlist!");

          // 🔹 Update localStorage
          const updatedWishlist = storedWishlist.filter(
            (id) => id !== experienceId,
          );
          localStorage.setItem("userWishlist", JSON.stringify(updatedWishlist));
        } else {
          toast.error(res.data.message || "Failed to remove from wishlist");
        }
      } else {
        // 🔹 Add to wishlist API
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE}/user/addToWishlist`,
          { experience_id: experienceId },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (res.data.status) {
          setIsWishlisted(true);
          toast.success("Added to wishlist!");

          // 🔹 Update localStorage
          if (!storedWishlist.includes(experienceId)) {
            storedWishlist.push(experienceId);
            localStorage.setItem(
              "userWishlist",
              JSON.stringify(storedWishlist),
            );
          }
        } else {
          toast.error(res.data.message || "Failed to add to wishlist");
        }
      }
    } catch (err) {
      console.error("Wishlist error:", err);

      if (err.response?.status === 401) {
        setLoginOpen(true);
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
      } else {
        toast.error(err.response?.data?.message || "Something went wrong");
      }
    }
  };

  //Banner api function Body

  const fetchBanners = async () => {
    try {
      setLoadingBanner(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getBanner`,
        {
          params: { page_name: "home" },
        },
      );

      if (res.data && !res.data.error && res.data.banners) {
        // ✅ force into array
        const bannersArray = Array.isArray(res.data.banners)
          ? res.data.banners
          : [res.data.banners];

        setBanners(
          bannersArray.map((b) => ({
            ...b,
            fullImage:
              res.data.base_url.replace(/\/$/, "") +
              "/" +
              b.image.replace(/^\//, ""),
          })),
        );
      }
    } catch (err) {
      console.error("Error fetching banners:", err);
    } finally {
      setLoadingBanner(false);
    }
  };

  //  Logout function
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    localStorage.removeItem("userWishlist");
    localStorage.removeItem("expiry");
    localStorage.removeItem("hostData");
    localStorage.removeItem("selectedCurrency");
    setUser(null);
    setIsOpen(false);
    toast.success("You have successfully logged out.");
    navigate("/");
  };

  // Calling function - when page reload - banner
  useEffect(() => {
    fetchBanners();
  }, []);

  const loadUserData = () => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      setUser(null);
    }
  };

  // 🔥 initial load + listen for changes
  useEffect(() => {
    loadUserData();
    window.addEventListener("userDataUpdated", loadUserData);
    return () => window.removeEventListener("userDataUpdated", loadUserData);
  }, []);

  const handleBecomeHost = async () => {
    const storedToken = localStorage.getItem("authToken");
    // const storedUser = localStorage.getItem("user");
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

    // ❌ Not logged in → open login modal with host type
    if (!storedToken || !storedUser) {
      setLoginType(2); // host
      setLoginOpen(true);
      return;
    }

    if (storedUser.signup_complete_status === "0") {
      // ✅ Open OtherInfo modal only
      setShowOtherInfoModal(true);
      return;
    }

    try {
      // ✅ logged in → call become host GET API
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/user/become-a-host`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        },
      );

      if (res.data && !res.data.error) {
        // ✅ Update localStorage with new token and user object
        if (res.data.token) {
          localStorage.setItem("authToken", res.data.token);
        }
        if (res.data.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
          setUser(res.data.user); // also update state immediately
        }
        // if (res.data.user.host_profile === 1) {
        //   navigate("/listing");
        // } else {
        //   navigate("/host-category");
        // }

        if (res.data.user.user_type === 2 && res.data.user.host_profile === 1) {
          navigate("/listing");
        } else if (
          res.data.user.user_type === 2 &&
          res.data.user.signup_complete_status === "0"
        ) {
          setShowOtherInfoModal(true);
        } else {
          navigate("/host-category");
        }
      } else {
        toast.error(
          res.data.message || "Something went wrong. Please try again.",
        );
      }
    } catch (err) {
      console.error("Error becoming host:", err);
    }
  };

  const handleSwitchToTraveler = async () => {
    const storedToken = localStorage.getItem("authToken");

    if (!storedToken) {
      // Not logged in → force login modal
      setLoginType(1);
      setLoginOpen(true);
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/switch-to-traveller`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        },
      );

      if (res.data && !res.data.error) {
        // ✅ update token & user in localStorage
        if (res.data.token) {
          localStorage.setItem("authToken", res.data.token);
        }
        if (res.data.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
          setUser(res.data.user);
        }

        // ✅ redirect to profile
        navigate("/");
      } else {
        toast.error(
          res.data.message || "Something went wrong. Please try again.",
        );
      }
    } catch (err) {
      console.error("Error switching to traveller:", err);
      // toast.error("Failed to switch to traveller. Please try again.");
    }
  };

  useEffect(() => {
    const closeMenu = () => {
      if (window.innerWidth <= 768) {
        setIsOpen(false);
        document.body.classList.remove("show-menu");
      }
    };

    closeMenu(); // run on initial route change
    document.addEventListener("click", closeMenu);

    return () => document.removeEventListener("click", closeMenu);
  }, [location.pathname]);

  useEffect(() => {
    const getCurrencyId = () =>
      JSON.parse(localStorage.getItem("selectedCurrency"))?.id || "";

    let currentCurrencyId = getCurrencyId();

    const refetchSearch = () => {
      if (filters.cityId || filters.countryId) {
        handleSearch({
          id: filters.cityId || filters.countryId,
          type: filters.cityId ? "city" : "country",
          name: filters.cityName || filters.countryName,
          // date: filters.date,
           arrive: searchParams.get("arrive") || "",
    depart: searchParams.get("depart") || "",
          guest: filters.guest,
        });
      }
    };

    const handleStorageChange = (e) => {
      if (e.key === "selectedCurrency") {
        const newId = JSON.parse(e.newValue)?.id;
        if (newId !== currentCurrencyId) {
          currentCurrencyId = newId;
          refetchSearch();
        }
      }
    };

    const interval = setInterval(() => {
      const newId = getCurrencyId();
      if (newId !== currentCurrencyId) {
        currentCurrencyId = newId;
        refetchSearch();
      }
    }, 1200);

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [filters]);

  return (
    <>
      {!isHome ? (
        // ----- Others Page Header -----
        <header
          id="fixedds"
          className={isSticky ? "others_pgs sticky" : "others_pgs"}
        >
          <div className="container">
            <nav>
              <div className="line">
                {isMobile && (
                  <p className="nav-text" onClick={toggleMobileMenu}>
                    <span></span>
                  </p>
                )}
                <div className="lgo_mg">
                  <Link to={"/"}>
                    <img
                      src={headerLogo || "/images/oth_pg_logo.svg"}
                      alt="Logo"
                    />
                  </Link>

                  {user && user.user_type === 2 && (
                    <div
                      className="bell-wrapper sr_ws_both mb_view_show"
                      onClick={() => navigate("/account-notification")}
                    >
                      <NotificationBell user={user} />
                    </div>
                  )}

                  {isExpeienceShare && (
                    <div className="mb_view_show shr_iconss">
                      <a href="#" onClick={toggleShare}>
                        <img src="/images/share-ios.png" alt="share" />
                      </a>
                      <a href="#" onClick={handleWishlist}>
                        <img
                          src={
                            isWishlisted
                              ? "/images/favourite-filled.png"
                              : "/images/favourite.png"
                          }
                          alt="favourite"
                        />
                      </a>
                    </div>
                  )}

                  {showShare && (
                    <div className="dtls_rightss">
                      <div className="titlss_cotnt">
                        <Sharepop
                          open={showShare}
                          onClose={(e) => {
                            e.preventDefault();
                            setShowShare(false);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Form Area */}
                {isExperiences && (
                  <div className="sort_form_arae">
                    <div className="container">
                      <SearchBar
                        onSearch={handleSearch}
                        loading={loading}
                        initialFilters={{
                          search: searchParams.get("location_search") || "",
                          arrive: searchParams.get("arrive") || "",
                          depart: searchParams.get("depart") || "",
                          adults: Number(searchParams.get("guest")) || 0,
                          children: Number(searchParams.get("child")) || 0,
                          infants: Number(searchParams.get("infants")) || 0,
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Top Nav */}
                <div className="top-nav s-12 l-12">
                  <ul className="lgnnss">
                    {/* {user &&( */}

                    {user ? (
                      user.user_type === 1 ? (
                        // logged in, normal user → show Become a host
                        <li className="mb_view_hide">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleBecomeHost();
                            }}
                          >
                            <i
                              class="fa fa-user-secret mb_view_show"
                              aria-hidden="true"
                            ></i>{" "}
                            Become a host
                          </a>
                        </li>
                      ) : (
                        // logged in, already host → show Switch to traveling
                        <>
                          <li>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSwitchToTraveler();
                              }}
                            >
                              Switch to experience
                            </a>
                          </li>
                          <li
                            className="bell-wrapper mb_view_hide"
                            onClick={() => navigate("/account-notification")}
                          >
                            <NotificationBell user={user} />
                          </li>
                        </>
                      )
                    ) : (
                      // not logged in → show Become a host
                      <li className="mb_view_hide">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setLoginType(2); // host
                            setLoginOpen(true);
                          }}
                        >
                          <i
                            class="fa fa-user-secret mb_view_show"
                            aria-hidden="true"
                          ></i>{" "}
                          Become a host
                        </a>
                      </li>
                    )}

                    {!user && (
                      <li>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            setIsOpen(false);
                            setLoginOpen(true);
                          }}
                        >
                          <i
                            className="fa fa-user mb_view_show"
                            aria-hidden="true"
                          ></i>{" "}
                          Log in / sign up
                        </a>
                      </li>
                    )}

                    {/* Show name if logged in, else language button */}
                    {user ? (
                      <li>
                        <span className="namess">
                          <Link
                            className="usr_mgs"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsOpen(!isOpen);
                            }}
                          >
                            <img
                              src={
                                user?.profile_image
                                  ? `${
                                      user?.base_url
                                        ? user.base_url
                                        : "https://admin.weyfarin.com"
                                    }/${user.profile_image.replace(/^\//, "")}`
                                  : "/images/user_dh.png"
                              }
                              alt={user?.first_name || "User"}
                            />
                          </Link>

                          <Link to={"/profile"}>
                            <span className="mb_view_show">
                              {user?.first_name} {user?.last_name}
                            </span>
                          </Link>
                        </span>
                      </li>
                    ) : (
                      <li className="br_iconns mb_view_hide">
                        <a
                          className="bntssd"
                          onClick={() => setLanguageOpen(true)}
                        >
                          <img src="/images/language.svg" alt="language" />
                        </a>
                      </li>
                    )}

                    {!user && (
                      <li className="br_iconns mb_view_hide last">
                        <a
                          className="bntssd bell"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsOpen(!isOpen);
                          }}
                        >
                          <img src="/images/buger.svg" alt="menu" />
                        </a>
                      </li>
                    )}
                    <div
                      className={`scope ${isOpen ? "active" : ""}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <ul>
                        {user && user.user_type === 1 && (
                          <>
                            <li>
                              <Link to={"user-wishlist"}>
                                <img
                                  src="/images/favourite.png"
                                  className="ic_other"
                                  alt="Wishlist"
                                />{" "}
                                Wishlist
                              </Link>
                            </li>
                            <li>
                              <Link to={"user-experience"}>
                                <img
                                  src="/images/experiences.png"
                                  className="ic_other"
                                  alt="Experiences"
                                />{" "}
                                Experiences
                              </Link>
                            </li>
                            <li>
                              <Link to={"/chat"}>
                                <img
                                  src="/images/bx_message.png"
                                  className="ic_other"
                                  alt="Mesage"
                                />{" "}
                                Message
                              </Link>
                            </li>
                            <li>
                              <Link to={"profile"}>
                                <img
                                  src="/images/user-profile.png"
                                  className="ic_other"
                                  alt="profile"
                                />{" "}
                                Profile
                              </Link>
                            </li>
                            <li>
                              <Link to={"user-setting"}>
                                <img
                                  src="/images/settings.png"
                                  className="ic_other"
                                  alt="Setting"
                                />{" "}
                                Account Setting
                              </Link>
                            </li>
                            <li>
                              <Link to={"notification"}>
                                <img
                                  src="/images/bell_ic.png"
                                  className="ic_other"
                                  alt="notification"
                                />{" "}
                                Notification
                              </Link>
                            </li>
                          </>
                        )}

                        {user && Number(user?.user_type) === 2 && (
                          // Number(user?.signup_complete_status) === 1 &&
                          <>
                            <li>
                              <Link to={"/dashboard"}>
                                <img
                                  src="/images/ac_setting_ic1.png"
                                  className="iconss"
                                  alt=""
                                />{" "}
                                Dashboard{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to={"/account-setting"}>
                                <img
                                  src="/images/setting_ic.png"
                                  alt=""
                                  className="iconss"
                                />{" "}
                                Account Setting
                              </Link>
                            </li>
                          </>
                        )}

                        {/* {user && ( */}
                        <li>
                          <a
                            onClick={() => {
                              if (!disableCurrency) {
                                setLanguageOpen(true);
                              }
                            }}
                            style={{
                              cursor: disableCurrency
                                ? "not-allowed"
                                : "pointer",
                              opacity: disableCurrency ? 0.5 : 1,
                            }}
                          >
                            <img
                              src="/images/language.svg"
                              className="ic_other"
                              alt="Language"
                            />{" "}
                            Currency
                          </a>
                        </li>
                        {/* )} */}

                        <li>
                          <Link to={"help-and-faq"}>
                            <i className="fa fa-question-circle-o"></i> Help
                            Center
                          </Link>
                        </li>

                        <li>
                          {user ? (
                            user.user_type === 1 ? (
                              // Traveler → show Become a host block
                              <a
                                className="become-host-block"
                                onClick={handleBecomeHost}
                                style={{ cursor: "pointer" }}
                              >
                                <p>Become a host</p>
                                <span>
                                  Get started with hosting today and unlock
                                  extra earnings
                                </span>
                              </a>
                            ) : (
                              // Host → show Switch to traveling block
                              <a
                                className="become-host-block"
                                onClick={handleSwitchToTraveler}
                                style={{ cursor: "pointer" }}
                              >
                                <p>Switch to experience</p>
                                <span>
                                  Return to exploring experiences as a traveler.
                                </span>
                              </a>
                            )
                          ) : (
                            // Not logged in → force login modal for host
                            <a
                              className="become-host-block"
                              onClick={() => {
                                setLoginType(2); // host
                                setLoginOpen(true);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <p>Become a host</p>
                              <span>
                                Get started with hosting today and unlock extra
                                earnings
                              </span>
                            </a>
                          )}
                        </li>

                        <li>
                          {
                            user && (
                              <>
                                <a
                                  href="javascript:void(0)"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout();
                                  }}
                                >
                                  <i
                                    className="fa fa-sign-out"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Logout
                                </a>
                              </>
                            )
                            //  : (
                            //   <a
                            //     onClick={(e) => {
                            //       e.preventDefault();
                            //       setIsOpen(false);
                            //       setLoginOpen(true);
                            //     }}
                            //   >
                            //     Log in or sign up
                            //   </a>
                            // )
                          }
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </header>
      ) : (
        <div id="home_parts_pgs" className={isSticky ? "sticky" : ""}>
          <header id="fixedds">
            <div className="container">
              <nav>
                <div className="line">
                  {isMobile && (
                    <p className="nav-text" onClick={toggleMobileMenu}>
                      <span></span>
                    </p>
                  )}
                  <div className="lgo_mg">
                    <Link to={"/"} className="mb_view_hide">
                      <img src={homeLogo || "/images/w_logo.png"} alt="Logo" />
                    </Link>
                    <Link to={"/"} className="scrollss">
                      {/* <img src="/images/oth_pg_logo.png" alt="Logo" /> */}
                      <img
                        src={headerLogo || "/images/oth_pg_logo.svg"}
                        alt="Logo"
                      />
                    </Link>
                  </div>

                  {user && user.user_type === 2 && (
                    <div
                      className="bell-wrapper mb_view_show"
                      onClick={() => navigate("/account-notification")}
                    >
                      <NotificationBell user={user} />
                    </div>
                  )}

                  <div className="top-nav s-12 l-12">
                    <ul className="lgnnss">
                      {/* {user &&( */}
                      {/* <li>
                    <a href="#" onClick={handleBecomeHost}>Become a host</a>
                  </li> */}
                      {user ? (
                        user.user_type === 1 ? (
                          // logged in, normal user → show Become a host
                          <li className="mb_view_hide">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleBecomeHost();
                              }}
                            >
                              <i
                                class="fa fa-user-secret mb_view_show"
                                aria-hidden="true"
                              ></i>{" "}
                              Become a host
                            </a>
                          </li>
                        ) : (
                          // logged in, already host → show Switch to traveling
                          <>
                            <li>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleSwitchToTraveler();
                                }}
                              >
                                Switch to experience
                              </a>
                            </li>
                            <li
                              className="bell-wrapper mb_view_hide"
                              onClick={() => navigate("/account-notification")}
                            >
                              <NotificationBell user={user} />
                            </li>
                          </>
                        )
                      ) : (
                        // not logged in → show Become a host
                        <li className="mb_view_hide">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoginType(2); // host
                              setLoginOpen(true);
                            }}
                          >
                            <i
                              class="fa fa-user-secret mb_view_show"
                              aria-hidden="true"
                            ></i>{" "}
                            Become a host
                          </a>
                        </li>
                      )}

                      {/* Show name if logged in, else language button */}
                      {!user && (
                        <li>
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              setIsOpen(false);
                              setLoginOpen(true);
                            }}
                          >
                            <i
                              className="fa fa-user mb_view_show"
                              aria-hidden="true"
                            ></i>{" "}
                            Log in / sign up
                          </a>
                        </li>
                      )}
                      {user ? (
                        <li>
                          <span className="namess">
                            <Link
                              className="usr_mgs"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsOpen(!isOpen);
                              }}
                            >
                              <img
                                src={
                                  user?.profile_image
                                    ? `${
                                        user?.base_url
                                          ? user.base_url
                                          : "https://admin.weyfarin.com"
                                      }/${user.profile_image.replace(
                                        /^\//,
                                        "",
                                      )}`
                                    : "/images/user_dh.png"
                                }
                                alt={user?.first_name || "User"}
                              />
                            </Link>

                            <Link to={"/profile"}>
                              <span className="mb_view_show">
                                {user?.first_name} {user?.last_name}
                              </span>
                            </Link>
                          </span>
                        </li>
                      ) : (
                        <li className="br_iconns mb_view_hide">
                          <a
                            className="bntssd"
                            onClick={() => setLanguageOpen(true)}
                          >
                            <img src="/images/language.svg" alt="language" />
                          </a>
                        </li>
                      )}

                      {/* Hamburger Icon */}
                      {!user && (
                        <li className="br_iconns mb_view_hide dstp">
                          <a
                            className="bntssd bell"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsOpen(!isOpen);
                            }}
                          >
                            <img src="/images/buger.svg" alt="menu" />
                          </a>
                        </li>
                      )}

                      {/* Hamburger Menu */}
                      <div
                        className={`scope ${isOpen ? "active" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ul>
                          {user && user.user_type === 1 && (
                            <>
                              <li>
                                <Link to={"user-wishlist"}>
                                  <img
                                    src="/images/favourite.png"
                                    className="ic_other"
                                    alt="Wishlist"
                                  />{" "}
                                  Wishlist
                                </Link>
                              </li>
                              <li>
                                <Link to={"user-experience"}>
                                  <img
                                    src="/images/experiences.png"
                                    className="ic_other"
                                    alt="Experiences"
                                  />{" "}
                                  Experiences
                                </Link>
                              </li>
                              <li>
                                <Link to={"/chat"}>
                                  <img
                                    src="/images/bx_message.png"
                                    className="ic_other"
                                    alt="Mesage"
                                  />{" "}
                                  Message
                                </Link>
                              </li>
                              <li>
                                <Link to={"profile"}>
                                  <img
                                    src="/images/user-profile.png"
                                    className="ic_other"
                                    alt="profile"
                                  />{" "}
                                  Profile
                                </Link>
                              </li>
                              <li>
                                <a href="/user-setting">
                                  <img
                                    src="/images/settings.png"
                                    className="ic_other"
                                    alt="Setting"
                                  />{" "}
                                  Account Setting
                                </a>
                              </li>
                            </>
                          )}

                          {user && Number(user?.user_type) === 2 && (
                            // Number(user?.signup_complete_status) === 1 &&
                            <>
                              <li>
                                <Link to={"/dashboard"}>
                                  <img
                                    src="/images/ac_setting_ic1.png"
                                    className="iconss"
                                    alt=""
                                  />{" "}
                                  Dashboard
                                </Link>
                              </li>

                              <li>
                                <Link to={"/account-setting"}>
                                  <img
                                    src="/images/setting_ic.png"
                                    className="iconss"
                                    alt=""
                                  />{" "}
                                  Account Setting
                                </Link>
                              </li>
                            </>
                          )}

                          <li>
                            <a
                              onClick={() => {
                                if (!disableCurrency) {
                                  setLanguageOpen(true);
                                }
                              }}
                              style={{
                                cursor: disableCurrency
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: disableCurrency ? 0.5 : 1,
                              }}
                            >
                              <img
                                src="/images/language.svg"
                                className="ic_other"
                                alt="Language"
                              />{" "}
                              Currency
                            </a>
                          </li>

                          <li>
                            <Link to={"help-and-faq"}>
                              <i className="fa fa-question-circle-o"></i> Help
                              Center
                            </Link>
                          </li>

                          <li>
                            {user ? (
                              user.user_type === 1 ? (
                                // Traveler → show Become a host block
                                <a
                                  className="become-host-block"
                                  onClick={handleBecomeHost}
                                  style={{ cursor: "pointer" }}
                                >
                                  <p>Become a host</p>
                                  <span>
                                    Get started with hosting today and unlock
                                    extra earnings
                                  </span>
                                </a>
                              ) : (
                                // Host → show Switch to traveling block
                                <a
                                  className="become-host-block"
                                  onClick={handleSwitchToTraveler}
                                  style={{ cursor: "pointer" }}
                                >
                                  <p>Switch to experience</p>
                                  <span>
                                    Return to exploring experiences as a
                                    traveler.
                                  </span>
                                </a>
                              )
                            ) : (
                              // Not logged in → force login modal for host
                              <a
                                className="become-host-block"
                                onClick={() => {
                                  setLoginType(2); // host
                                  setLoginOpen(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <p>Become a host</p>
                                <span>
                                  Get started with hosting today and unlock
                                  extra earnings
                                </span>
                              </a>
                            )}
                          </li>

                          <li>
                            {user && (
                              <>
                                <a
                                  href="javascript:void(0)"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout();
                                  }}
                                >
                                  <i
                                    className="fa fa-sign-out"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Logout
                                </a>
                              </>
                            )}
                          </li>
                        </ul>
                      </div>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </header>

          {/* Banner Area */}
          {isHome && (
            <div className="hm_banner">
              <div className="hm_bgr_hm_area">
                {loadingBanner ? (
                  <div className="text-center py-10">
                    <div className="skeletoloading banner-skeleton"></div>
                    <div className="banner-txt-skeleton">
                      <div className="skeleton-text short"></div>
                      <div className="skeleton-text long"></div>
                      <div className="skeleton-btn"></div>
                    </div>
                  </div>
                ) : banners.length > 0 ? (
                  banners.map((banner) => (
                    <div key={banner.id} className="single-banner">
                      {banner.type === "image" ? (
                        <img
                          src={banner.fullImage || "/images/w_banner.png"}
                          className="bgr_hm"
                          alt={banner.name}
                        />
                      ) : banner.type === "video" ? (
                        <video
                          className="bgr_hm"
                          autoPlay
                          loop
                          muted
                          playsInline
                          controls={false}
                        >
                          <source src={banner.fullImage} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : null}
                      <div className="b_context_t_arae">
                        <div className="meddils">
                          <h2>{banner.name}</h2>
                          <p className="mb_view_hide">{banner.description}</p>
                          <Link
                            to={banner.explore_more_link}
                            className="bnt_butnss"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Start Exploring
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : null}
              </div>
              <div className="sort_form_arae">
                <div className="container">
                  <SearchBar
                    onSearch={handleSearch}
                    loading={loading}
                    initialFilters={{
                      search: searchParams.get("location_search") || "",
                      arrive: searchParams.get("arrive") || "",
                      depart: searchParams.get("depart") || "",
                      adults: Number(searchParams.get("guest")) || 0,
                      children: Number(searchParams.get("child")) || 0,
                      infants: Number(searchParams.get("infants")) || 0,
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Modals */}
      <LoginModal
        isOpen={loginOpen}
        onClose={() => setLoginOpen(false)}
        userType={loginType}
      />
      {/* <OtherInfo /> */}
      {showOtherInfoModal && (
        <OtherInfo
          isOpen={showOtherInfoModal}
          onClose={() => setShowOtherInfoModal(false)}
          userType={loginType}
        />
      )}
      <LanguageModal
        isOpen={languageOpen}
        onClose={() => setLanguageOpen(false)}
      />
    </>
  );
}

export default Header;
